import { library, dom } from '@fortawesome/fontawesome-svg-core';
import {
    faFilePdf as fasFaFilePdf
} from '@fortawesome/pro-solid-svg-icons';
// import {} from '@fortawesome/pro-regular-svg-icons';
import {
    faCheck as falFaCheck,
    faMagnifyingGlass as falFaMagnifyingGlass,
    faMoneyBill as falFaMoneyBill,
    faPenLine as falFaPenLine,
    faSave as falFaSave,
    faTimes as falFaTimes,
    faUserTimes as falFaUserTimes,
    faUserEdit as falFaUserEdit,
    faUserPlus as falFaUserPlus,
} from '@fortawesome/pro-light-svg-icons';
// import {} from '@fortawesome/pro-thin-svg-icons';
// import {} from '@fortawesome/pro-duotone-svg-icons';
// import {} from '@fortawesome/free-brands-svg-icons';

// Add the icons
library.add(
    // Light
    falFaCheck,
    falFaMagnifyingGlass,
    falFaMoneyBill,
    falFaPenLine,
    falFaSave,
    falFaTimes,
    falFaUserEdit,
    falFaUserPlus,
    falFaUserTimes,

    // Solid
    fasFaFilePdf,
);

// Run the replace
dom.i2svg().then(function () {
    console.log("Watching the DOM for new icons..");
    dom.watch();
});
